import React from 'react';
import { MailIcon, PhoneIcon, MapPinIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gray-900 dark:bg-black text-white py-12" data-id="element-87">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-88">
        <div className="grid md:grid-cols-4 gap-8 mb-8" data-id="element-89">
          {/* Company Info */}
          <div className="md:col-span-2" data-id="element-90">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/uo4iwWVSECmyeiyJjvjjvp/K_V4-2.png" alt="KONTAXES" className="h-16 w-auto mb-4" data-id="element-91" />
            <p className="text-gray-400 mb-4" data-id="element-92">
              Contabilidad, Impuestos, Asesoría Financiera y Consultoría
            </p>
            <p className="text-sm text-gray-500" data-id="element-93">De números a decisiones</p>
          </div>

          {/* Contact */}
          <div data-id="element-94">
            <h3 className="text-lg font-bold mb-4" data-id="element-95">Contacto</h3>
            <div className="space-y-3" data-id="element-96">
              <a href="mailto:info@kontaxes.com" className="flex items-center text-gray-400 hover:text-purple-400 transition-colors" data-id="element-97">
                <MailIcon size={18} className="mr-2" data-id="element-98" />
                info@kontaxes.com
              </a>
              <a href="https://wa.me/50235174713" target="_blank" rel="noopener noreferrer" className="flex items-center text-gray-400 hover:text-purple-400 transition-colors" data-id="element-99">
                <PhoneIcon size={18} className="mr-2" data-id="element-100" />
                +502 3517-4713
              </a>
              <div className="flex items-start text-gray-400" data-id="element-101">
                <MapPinIcon size={18} className="mr-2 mt-1 flex-shrink-0" data-id="element-102" />
                <span data-id="element-103">Guatemala</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-104">
            <h3 className="text-lg font-bold mb-4" data-id="element-105">Enlaces Rápidos</h3>
            <ul className="space-y-2" data-id="element-106">
              {['Servicios', 'Cotizador', 'Herramientas', 'Equipo', 'Clientes'].map(link => <li key={link} data-id="element-107">
                  <button onClick={() => {
                const element = document.getElementById(link.toLowerCase());
                element?.scrollIntoView({
                  behavior: 'smooth'
                });
              }} className="text-gray-400 hover:text-purple-400 transition-colors" data-id="element-108">
                    {link}
                  </button>
                </li>)}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8" data-id="element-109">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0" data-id="element-110">
            <p className="text-gray-500 text-sm" data-id="element-111">
              © {new Date().getFullYear()} KONTAXES. Todos los derechos
              reservados.
            </p>
            <div className="flex items-center space-x-6" data-id="element-112">
              <a href="https://nerd.lat" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-purple-400 transition-colors text-sm" data-id="element-113">
                Potenciado por <span className="font-bold" data-id="element-114">nerd.lat</span>
              </a>
              <a href="https://www.odoo.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-purple-400 transition-colors text-sm" data-id="element-115">
                Potenciado con <span className="font-bold" data-id="element-116">Odoo</span>
              </a>
            </div>
          </div>
          <p className="text-center text-gray-600 text-xs mt-4" data-id="element-117">
            Utilizando la tecnología y el profesionalismo
          </p>
        </div>
      </div>
    </footer>;
}